/* eslint-disable no-new */
/* eslint-disable import/no-cycle */
/* sliders
 ========================================================================== */
import { A11y, Autoplay, Controller, EffectCoverflow, EffectFade, Mousewheel, Navigation, Pagination, Swiper, Thumbs, } from 'swiper';
import { SLIDE_CHANGE, VARIANT_SWITCH } from '../../events';
import { switchVariantsFromSlider } from '../multiProducts/switcher';
import { switchVariant } from '../product/switcher';
import config, { navigationConfig, paginationConfig } from './default';
import { addParallaxOnScrollToSwiper } from './parallaxEffect';
Swiper.use([Thumbs, Navigation, Pagination, EffectFade, EffectCoverflow, Autoplay, Mousewheel, A11y, Controller]);
// Map to track initialized sliders and prevent duplicates
const initializedSliders = new WeakMap();
// Intersection Observer options
const observerOptions = {
    root: null,
    rootMargin: '50px', // Start loading 50px before element enters viewport
};
/**
 * Utility function to initialize sliders only when visible in viewport
 */
function initSliderOnVisible(selector, initFunction, options = {}) {
    const elements = document.querySelectorAll(selector);
    if (elements.length === 0) {
        return;
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !initializedSliders.has(entry.target)) {
                const result = initFunction(entry.target);
                if (result instanceof Swiper) {
                    initializedSliders.set(entry.target, result);
                }
                // Stop observing this element after initialization
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    elements.forEach((element) => {
        // Only observe elements that haven't been initialized yet
        if (!initializedSliders.has(element)) {
            observer.observe(element);
        }
    });
}
/**
 * Initialize slider immediately (for critical sliders that should load instantly)
 */
function initSliderImmediately(selector, initFunction) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
        if (!initializedSliders.has(element)) {
            const result = initFunction(element);
            if (result instanceof Swiper) {
                initializedSliders.set(element, result);
            }
        }
    });
}
// horizontal slider (default)
export function horizontal() {
    initSliderOnVisible('.js-slider', (element) => {
        const customConfig = {};
        const customNavigationConfig = {
            prevEl: '.js-slider-btn-prev',
            nextEl: '.js-slider-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// vertical slider
export function vertical() {
    initSliderOnVisible('.js-slider-vertical', (element) => {
        const customConfig = {
            direction: 'vertical',
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-vertical-btn-prev',
            nextEl: '.js-slider-vertical-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
export function otherVariantsProduct() {
    initSliderOnVisible('.js-slider-other-variants-product', (element) => {
        const customConfig = {
            slidesPerView: 1.4,
            spaceBetween: 12,
            threshold: 5,
            roundLengths: true,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.51,
                    spaceBetween: 18,
                    allowTouchMove: true,
                    grabCursor: false,
                    centeredSlides: false,
                },
            },
        };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
export function otherVariantsProductLoop() {
    initSliderOnVisible('.js-slider-other-variants-product-loop', (element) => {
        const customConfig = {
            slidesPerView: 1.4,
            spaceBetween: 12,
            threshold: 5,
            roundLengths: true,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            loop: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.51,
                    spaceBetween: 18,
                    allowTouchMove: true,
                    grabCursor: false,
                    centeredSlides: false,
                    loop: false,
                },
            },
        };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// crosseling product slider
export function crosselingProduct() {
    initSliderOnVisible('.js-slider-crosseling-product', (element) => {
        const customConfig = {
            slidesPerView: 1.4,
            spaceBetween: 12,
            threshold: 5,
            roundLengths: true,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.51,
                    spaceBetween: 18,
                    allowTouchMove: true,
                    grabCursor: false,
                },
            },
        };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// centered crosseling product slider
export function centeredCrosselingProduct() {
    initSliderOnVisible('.js-slider-centered-crosseling-product', (element) => {
        const customConfig = {
            slidesPerView: 2.25,
            spaceBetween: 14,
            allowTouchMove: true,
            grabCursor: true,
            centerInsufficientSlides: false,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                    allowTouchMove: false,
                    grabCursor: false,
                    centerInsufficientSlides: true,
                },
            },
        };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// Product Slider - Critical slider, initialize immediately
export function product() {
    initSliderImmediately('.js-slider-product', (productElement) => {
        const isMultiProduct = !!document.querySelector('[data-multi-product]');
        // thumbs config
        const thumbsComponent = document.querySelector('.js-slider-thumbs');
        if (!thumbsComponent)
            return;
        const thumbsSlides = Array.from(thumbsComponent.querySelectorAll('.c-slider__item'));
        const initialSlide = thumbsSlides.findIndex((el) => !!el.dataset.selectedVariant) ||
            parseInt(thumbsComponent.dataset.initialSlide, 10) ||
            0;
        const slidesPerView = 5;
        const thumbsSlider = new Swiper(thumbsComponent, {
            ...config,
            initialSlide,
            rewind: true,
            slidesPerView,
            spaceBetween: parseInt(getComputedStyle(document.body).getPropertyValue('--swiper-space-between'), 10),
            watchSlidesProgress: true,
            allowTouchMove: false,
            breakpoints: {
                1025: {
                    direction: 'vertical',
                },
            },
            on: {
                init: () => {
                    thumbsComponent.style.opacity = '1';
                },
            },
        });
        const customProductComponent = productElement;
        const slides = Array.from(customProductComponent.querySelectorAll('.c-slider__item'));
        const productSlider = new Swiper(customProductComponent, {
            ...config,
            navigation: {
                ...navigationConfig,
                prevEl: '.js-slider-product-btn-prev',
                nextEl: '.js-slider-product-btn-next',
            },
            initialSlide,
            rewind: true,
            effect: 'fade',
            breakpoints: {
                1025: {
                    allowTouchMove: false,
                },
            },
            on: {
                init: () => {
                    // In some cases the thumb slider is not initialized correctly
                    setTimeout(() => {
                        productSlider.update();
                    }, 400);
                },
            },
            thumbs: {
                swiper: thumbsSlider,
                slideThumbActiveClass: 'is-active',
            },
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                dynamicMainBullets: 5,
            },
        });
        // Thumbs manual pagination
        document.querySelector('.js-slider-thumbs-btn-prev')?.addEventListener('click', () => {
            productSlider.slidePrev();
        });
        document.querySelector('.js-slider-thumbs-btn-next')?.addEventListener('click', () => {
            productSlider.slideNext();
        });
        productSlider.on('slideChangeTransitionStart', () => {
            // Pause all videos when a slide changes
            const videos = Array.from(customProductComponent.querySelectorAll('.js-slider-product-video'));
            videos.forEach((video) => {
                video.pause();
            });
        });
        productSlider.on('slideChange', (e) => {
            const event = new Event(SLIDE_CHANGE);
            customProductComponent.dispatchEvent(event);
            const previousIndex = e.previousIndex;
            const currentIndex = e.realIndex;
            const previousSlide = slides[previousIndex];
            const slide = slides[currentIndex];
            const slideVideo = slide.querySelector('.js-slider-product-video');
            if (isMultiProduct) {
                const shouldSwitchVariant = !previousSlide || slide.dataset.variantIds !== previousSlide.dataset.variantIds;
                if (shouldSwitchVariant) {
                    switchVariantsFromSlider(JSON.parse(slide.dataset.variantIds));
                    productSlider.update();
                }
            }
            else {
                const shouldSwitchVariant = !previousSlide || slide.dataset.variantId !== previousSlide.dataset.variantId;
                if (shouldSwitchVariant) {
                    switchVariant(slide.dataset.variantId, false);
                    productSlider.update();
                }
            }
            // Play video when a slide is active
            setTimeout(() => {
                if (slideVideo) {
                    // if video is loaded, play
                    if (slideVideo.readyState === 4) {
                        slideVideo.play();
                    }
                    else {
                        // else wait for loaded state, then play
                        slideVideo.addEventListener('loadeddata', () => slideVideo.play(), { once: true });
                    }
                }
            }, 0);
        });
        // Handle variant switch sync
        document.addEventListener(VARIANT_SWITCH, (e) => {
            if (!e.detail.shouldUpdateSlider) {
                return;
            }
            const index = slides.findIndex((el) => e.detail.variantId
                ? el.dataset.variantId === e.detail.variantId
                : el.dataset.variantIds.includes(e.detail.variantIds.toString()));
            productSlider.slideTo(index, 0, false);
            thumbsSlider.slideTo(index, 0, false);
            productSlider.update();
        });
        return productSlider;
    });
}
// loop slider
export function loop() {
    initSliderOnVisible('.js-slider-loop', (element) => {
        const customConfig = {
            loop: true,
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-loop-btn-prev',
            nextEl: '.js-slider-loop-btn-next',
        };
        const customPaginationConfig = {
            el: '.js-slider-loop-pagination',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        customConfig.pagination = { ...paginationConfig, ...customPaginationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// loop autoplay slider
export function loopAutoplay() {
    const sliders = Array.from(document.querySelectorAll('.js-slider-loop-autoplay'));
    sliders.forEach((slider, index) => {
        initSliderOnVisible(`.js-slider-${slider.dataset.id}`, (element) => {
            const customConfig = {};
            const slides = slider.querySelectorAll('.c-slider__item');
            if (slides.length > 1) {
                customConfig.loop = true;
                customConfig.autoplay = {
                    delay: 3000,
                    disableOnInteraction: false,
                };
            }
            const compositionId = slider.dataset.id;
            const videos = slider.querySelectorAll('video');
            const customNavigationConfig = {
                prevEl: `.js-slider-loop-autoplay-btn-prev-${compositionId}`,
                nextEl: `.js-slider-loop-autoplay-btn-next-${compositionId}`,
            };
            const customPaginationConfig = {
                el: `.js-slider-loop-autoplay-pagination-${compositionId}`,
            };
            customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
            customConfig.pagination = { ...paginationConfig, ...customPaginationConfig };
            const mySwiper = new Swiper(element, { ...config, ...customConfig });
            // Segmented control to select the menu color
            if (index === 0) {
                mySwiper.on('slideChangeTransitionEnd', () => {
                    const event = new Event(SLIDE_CHANGE);
                    slider.dispatchEvent(event);
                });
            }
            videos.forEach((video) => {
                video.addEventListener('click', () => {
                    video.paused ? mySwiper.autoplay.stop() : mySwiper.autoplay.start();
                });
            });
            return mySwiper;
        });
    });
}
// faq slider
export function faqSlider() {
    initSliderOnVisible('.js-slider-faq', (element) => {
        const breakpoint = window.matchMedia('(min-width: 48em)');
        const customConfig = {
            slidesPerView: 2,
            spaceBetween: 14,
            loop: true,
        };
        const customPaginationConfig = {
            el: '.js-slider-faq-pagination',
        };
        customConfig.pagination = { ...paginationConfig, ...customPaginationConfig };
        let mySwiper;
        const enableSwiper = () => {
            if (!mySwiper) {
                mySwiper = new Swiper(element, { ...config, ...customConfig });
            }
        };
        const breakpointChecker = () => {
            if (breakpoint.matches) {
                if (mySwiper) {
                    mySwiper.destroy(true, true);
                    mySwiper = null;
                }
            }
            else {
                enableSwiper();
            }
        };
        breakpointChecker();
        breakpoint.addListener(breakpointChecker);
        return mySwiper;
    });
}
// CMS Slider-3-visible-center
export function cmsSlider3Center() {
    const sliders = Array.from(document.querySelectorAll('.js-slider-cms-slider-3-visible-center'));
    sliders.forEach((slider) => {
        const compositionId = slider.dataset.id;
        initSliderOnVisible(`.js-slider-cms-slider-3-visible-center-${compositionId}`, (imageElement) => {
            const customConfig = {
                slidesPerView: 1,
                spaceBetween: 32,
                allowTouchMove: true,
                grabCursor: true,
                loop: true,
                mousewheel: {
                    forceToAxis: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        centeredSlides: true,
                    },
                },
            };
            const textCustomConfig = {
                slidesPerView: 1,
                spaceBetween: 32,
                allowTouchMove: false,
                loop: true,
                mousewheel: {
                    forceToAxis: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        centeredSlides: true,
                    },
                },
            };
            const customNavigationConfig = {
                prevEl: `.js-slider-cms-slider-3-visible-center-btn-prev-${compositionId}`,
                nextEl: `.js-slider-cms-slider-3-visible-center-btn-next-${compositionId}`,
            };
            const customPaginationConfig = {
                el: `.js-slider-cms-slider-3-visible-center-pagination-${compositionId}`,
                dynamicBullets: true,
                clickable: true,
                dynamicMainBullets: 2,
            };
            customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
            customConfig.pagination = customPaginationConfig;
            const imagesSwiper = new Swiper(imageElement, {
                ...config,
                ...customConfig,
            });
            const textElement = document.querySelector(`.js-slider-cms-slider-3-visible-center-text-${compositionId}`);
            if (textElement) {
                const textSwiper = new Swiper(textElement, {
                    ...config,
                    ...textCustomConfig,
                });
                imagesSwiper.controller.control = textSwiper;
                textSwiper.controller.control = imagesSwiper;
            }
            return imagesSwiper;
        });
    });
}
// CMS LBM text 50 50 slider color - slider 2 center
export function cmsSlider2Center() {
    const sliders = Array.from(document.querySelectorAll('.js-slider-cms-slider-2-center'));
    sliders.forEach((slider) => {
        const compositionId = slider.dataset.id;
        initSliderOnVisible(`.js-slider-${compositionId}`, (element) => {
            const nbSlides = parseInt(slider.dataset.nbSlides, 10);
            const gap = parseInt(slider.style.getPropertyValue('--slider-gap'), 10);
            const slidesPerView = nbSlides >= 6 ? 4 : 2.2;
            const breakpointLoop = nbSlides >= 8;
            const customConfig = {
                slidesPerView: 1,
                spaceBetween: gap,
                initialSlide: 1,
                loop: true,
                allowTouchMove: true,
                grabCursor: true,
                mousewheel: {
                    forceToAxis: true,
                },
                pagination: {
                    clickable: true,
                    el: `.js-slider-cms-slider-2-center-pagination-${compositionId}`,
                    dynamicBullets: true,
                    enabled: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView,
                        loop: breakpointLoop,
                        slidesPerGroup: 2,
                        initialSlide: 0,
                        pagination: {
                            enabled: false,
                        },
                    },
                },
            };
            const customNavigationConfig = {
                prevEl: `.js-slider-cms-slider-2-center-btn-prev-${compositionId}`,
                nextEl: `.js-slider-cms-slider-2-center-btn-next-${compositionId}`,
            };
            customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
            return new Swiper(element, { ...config, ...customConfig });
        });
    });
}
// CMS Slider-4-visible
export function cmsSlider4() {
    initSliderOnVisible('.js-slider-cms-slider-4-visible', (element) => {
        const customConfig = {
            slidesPerView: 1.7,
            spaceBetween: 14,
            allowTouchMove: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.7,
                },
                1025: {
                    slidesPerView: 3.7,
                },
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-cms-slider-4-visible-btn-prev',
            nextEl: '.js-slider-cms-slider-4-visible-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// CMS Slider-5-visible
export function cmsSlider5() {
    initSliderOnVisible('.js-slider-cms-slider-5-visible', (element) => {
        const customConfig = {
            slidesPerView: 2.4,
            spaceBetween: 10,
            allowTouchMove: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.4,
                    spaceBetween: 14,
                },
                1025: {
                    slidesPerView: 4.4,
                    spaceBetween: 14,
                },
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-cms-slider-5-visible-btn-prev',
            nextEl: '.js-slider-cms-slider-5-visible-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// CMS Slider-7-visible
export function cmsSlider7() {
    initSliderOnVisible('.js-slider-cms-slider-7-visible', (element) => {
        const customConfig = {
            slidesPerView: 3.5,
            spaceBetween: 10,
            allowTouchMove: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4.5,
                    spaceBetween: 14,
                },
                1025: {
                    slidesPerView: 6.5,
                    spaceBetween: 14,
                },
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-cms-slider-7-visible-btn-prev',
            nextEl: '.js-slider-cms-slider-7-visible-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// CMS Colorama Slider 5 Text
export function coloramaSlider5Text() {
    const sliders = Array.from(document.querySelectorAll('.js-slider-cms-colorama-slider-5-text'));
    sliders.forEach((slider) => {
        const compositionId = slider.dataset.id;
        initSliderOnVisible(`.js-slider-cms-colorama-slider-5-text-${compositionId}`, (element) => {
            const slides = slider.querySelectorAll(':scope > .c-slider__list > .c-slider__item');
            const customConfig = {
                slidesPerView: 1.3,
                spaceBetween: 4,
                slidesOffsetBefore: 58,
                freeMode: {
                    enabled: true,
                    sticky: false,
                    momentumRatio: 0.6,
                    momentumBounce: false,
                    momentumBounceRatio: 0,
                    momentumVelocityRatio: 0.8,
                },
                allowTouchMove: true,
                longSwipes: true,
                longSwipesRatio: 0.3,
                longSwipesMs: 200,
                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4.5,
                        spaceBetween: 4,
                        slidesOffsetBefore: 78,
                        grabCursor: true,
                    },
                },
            };
            // Swiper initialization
            const swiper = new Swiper(element, { ...config, ...customConfig });
            // Parallax effect
            addParallaxOnScrollToSwiper(swiper);
            return swiper;
        });
    });
}
// Cross sell
export function crossSell() {
    initSliderOnVisible('.js-slider-modal-cross-sell', (element) => {
        const customConfig = {
            slidesPerView: 1,
            spaceBetween: 28,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            mousewheel: {
                forceToAxis: true,
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-modal-cross-sell-btn-prev',
            nextEl: '.js-slider-modal-cross-sell-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// Popin Cross Sell Product
export function crossSellProductPopin() {
    initSliderOnVisible('.js-slider-modal-cross-sell-product-popin', (element) => {
        const customConfig = {
            slidesPerView: 1.4,
            spaceBetween: 12,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            initialSlide: 1,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 18,
                    centeredSlides: false,
                    initialSlide: 0,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 18,
                    allowTouchMove: false,
                    grabCursor: false,
                    centeredSlides: false,
                    initialSlide: 0,
                },
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-modal-cross-sell-product-popin-btn-prev',
            nextEl: '.js-slider-modal-cross-sell-product-popin-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// Shop the look
export function shopTheLook() {
    initSliderOnVisible('.js-slider-modal-shop-the-look', (element) => {
        const customConfig = {
            slidesPerView: 1.4,
            spaceBetween: 14,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            initialSlide: 1,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    initialSlide: 0,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 18,
                    allowTouchMove: false,
                    grabCursor: false,
                    centeredSlides: false,
                    initialSlide: 0,
                },
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-modal-shop-the-look-btn-prev',
            nextEl: '.js-slider-modal-shop-the-look-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// CMS Block Product Slider
export function cmsBlockProduct() {
    initSliderOnVisible('.js-slider-block-product', (element) => {
        const sliderElement = element;
        const customConfig = {};
        const slides = sliderElement.querySelectorAll('.c-slider__item');
        if (slides.length > 1) {
            customConfig.loop = true;
        }
        const customNavigationConfig = {
            prevEl: sliderElement.parentNode.querySelector('.c-slider__btn--prev'),
            nextEl: sliderElement.parentNode.querySelector('.c-slider__btn--next'),
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(sliderElement, {
            ...config,
            slidesPerView: 'auto',
            ...customConfig,
            on: {
                slideChangeTransitionStart: () => {
                    const videos = Array.from(sliderElement.querySelectorAll('video'));
                    // Pause all videos when a slide changes
                    videos.forEach((video) => {
                        video.pause();
                    });
                },
                slideChangeTransitionEnd: (e) => {
                    const event = new Event(SLIDE_CHANGE);
                    sliderElement.dispatchEvent(event);
                    const slide = e.slides[e.activeIndex];
                    const slideVideo = slide.querySelector('video');
                    // Play video when a slide is active
                    if (slideVideo) {
                        // if video is loaded, play
                        if (slideVideo.readyState >= 2) {
                            slideVideo.play();
                        }
                        else {
                            // else wait for loaded state, then play
                            slideVideo.addEventListener('loadeddata', () => slideVideo.play(), { once: true });
                        }
                    }
                },
            },
        });
    });
}
export function crossSellOtherSizes() {
    initSliderOnVisible('.js-slider-other-sizes-product', (element) => {
        const customConfig = {
            slidesPerView: 2,
            spaceBetween: 12,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 14,
                    allowTouchMove: true,
                    grabCursor: false,
                },
            },
        };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
// Lookbook Edito Slider 5
export function lookbookEditoSlider5() {
    initSliderOnVisible('.js-slider-lbe-slider-5', (element) => {
        const customConfig = {
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            loop: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 120,
                modifier: 1,
                slideShadows: false,
            },
        };
        const customNavigationConfig = {
            prevEl: '.js-slider-btn-prev',
            nextEl: '.js-slider-btn-next',
        };
        customConfig.navigation = { ...navigationConfig, ...customNavigationConfig };
        return new Swiper(element, { ...config, ...customConfig });
    });
}
